import { FC, MouseEvent } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip, RideStatusIndicator } from "@ryde/controls";
import { ICoursesCalendarSlotDto } from "@ryde/shared";

import { buildCoursesCalendarRideRouteTooltip } from "./courses-calendar-cell.tooltip-utils";

interface ICoursesCalendarCellRideStatusProps {
  slot: ICoursesCalendarSlotDto;
  tooltipDisabled?: boolean;
  onRideOpen: (id: number) => void;
}

export const CoursesCalendarCellRideStatus: FC<
  ICoursesCalendarCellRideStatusProps
> = ({ slot, tooltipDisabled, onRideOpen }) => {
  const { t } = useTranslation();
  const rideId = slot.rideId;

  if (!slot.hasRide || typeof rideId !== "number") {
    return null;
  }

  const routeTooltip = buildCoursesCalendarRideRouteTooltip({
    t,
    slot,
    onRideIdClick: onRideOpen,
  });

  const handleOpenRide = (e: MouseEvent): void => {
    e.stopPropagation();
    onRideOpen(rideId);
  };

  return (
    <FramerTooltip content={routeTooltip} tooltipDisabled={tooltipDisabled}>
      <span
        className="status_cell cc-status--interactive cc-ride-status-block"
        onClick={handleOpenRide}
        role="button"
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            handleOpenRide(e as unknown as MouseEvent);
          }
        }}
      >
        <RideStatusIndicator status={slot.rideStatus} fontSize="12px" />
      </span>
    </FramerTooltip>
  );
};
